// Src/utils/loadIcons.js
export function loadIcon(iconName) {
    try {
        return require(`/static/assets/images/icons/${iconName}.svg`);
    } catch (error) {
        console.error(`Icon ${iconName} not found.`);
        return ''; // Return an empty string or fallback icon
    }
}
